var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 4H16C9.382 4 4 9.382 4 16V42C4 42.5304 4.21071 43.0391 4.58579 43.4142C4.96086 43.7893 5.46957 44 6 44H32C38.618 44 44 38.618 44 32V16C44 9.382 38.618 4 32 4ZM22 32.828L14.586 25.414L17.414 22.586L22 27.172L31.586 17.586L34.414 20.414L22 32.828Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.f15c72e1a09d0279bf857878883cb1ac.svg";
export { ForwardRef as ReactComponent };